import { useEffect, useState } from 'react';

export function useTrigger(timeOut = 20000) {
  const [trigger, setTrigger] = useState(false);
  let interval;
  const trig = () => {
    setTrigger(trigeer => !trigeer);
  };
  useEffect(() => {
    interval = setInterval(trig, timeOut);
    return () => {
      clearInterval(interval);
    };
  });

  return { trigger, trig };
}
